module.exports = __webpack_public_path__ + "img/ministry-of-education.42c060f8.png";